import { createSelector } from 'reselect';
import { ExtraChargesSlice } from '@/redux/modules/billingManagement/extraCharges/extraCharges.types';
import { GlobalState } from '@/redux/store';

const sliceSelector = (state: GlobalState): ExtraChargesSlice => state.extraCharges;

export const getExtraChargesTypes = createSelector([sliceSelector], (slice) => slice.extraChargesTypes);

export const getExtraChargeSaveWasSuccessful = createSelector([sliceSelector], (slice) => slice.wasSaveSuccessful);
